<div class="header-tabs" *ngIf="tabs?.length">
  <ion-button
    *ngFor="let tab of tabs; trackBy: trackById"
    fill="clear"
    class="header-tab"
    [class.active]="selectedTab === tab.value"
    [disabled]="tab.disable"
    (click)="onTabClick(tab.value)">
    {{ tab.displayText | translate }}
    <span class="header-tab-badge" *ngIf="tab.badgeText">{{ tab.badgeText }}</span>
  </ion-button>
</div>
